import Typography from '@material-ui/core/Typography';
import React from 'react';
import { Observe } from 'rewire-core';
import { INameEntity, IUdf } from '../DataTypes';
import { UdfValue } from '../schedule/UdfExpressionField';
import { formatUdfValue } from '../utility/Formatters';
import { makeStyles, Theme } from '../utility/styles';

const udfsStyle = (theme: Theme) => ({
  root: {
    margin: 4,
    display: 'flex',
    flexDirection: 'column',
    padding: 8,
    border: `1px solid ${theme.palette.grey['300']}`,
    borderRadius: 5,
  },
  label: {
    flex: 1,
    fontWeight: 'bold',
    textAlign: 'right',
    paddingRight: 4,
    fontSize: 12,
  },
  value: {
    flex: 2,
    fontSize: 12,
  },
  udf: {
    display: 'flex',
    flex: '1',
    alignItems: 'center',
  },
});

const useUdfsStyle = makeStyles(udfsStyle);

function FormatUdf(props: { document: INameEntity; udf: IUdf }): JSX.Element | null {
  if (props.udf.type === 'expression') {
    const value = props.document.fields?.[props.udf.name];
    if (!value) return null;
    return <>{formatUdfValue(props.udf, value)}</>;
  }
  const value = props.document.fields?.[props.udf.name];
  if (!value) return null;
  return <>{formatUdfValue(props.udf, value)}</>;
}

const Udf = ({ item, udf, classes }: { item: INameEntity; udf: IUdf; classes: any }) => (
  <Observe>
    {() => (
      <div className={classes.udf}>
        <Typography variant="subtitle1" className={classes.label}>
          {udf.displayName}:
        </Typography>
        <Typography variant="subtitle1" className={classes.value}>
          <FormatUdf udf={udf} document={item} />
        </Typography>
      </div>
    )}
  </Observe>
);

export default ({ udfs, item }: any) => {
  const classes = useUdfsStyle();

  return (
    <Observe
      render={() =>
        !udfs || udfs.length === 0 ? null : (
          <div className={classes.root}>
            {udfs.map((udf: IUdf) => (
              <Udf key={udf.id} item={item} classes={classes} udf={udf} />
            ))}
          </div>
        )
      }
    />
  );
};
